import { Injectable } from '@angular/core'
import { getFirebaseApp } from '../firebase'
import { getAuth, Auth } from 'firebase/auth'
import {
  getFirestore,
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
  Firestore,
} from 'firebase/firestore'
import { getFunctions, Functions } from 'firebase/functions'
import { getStorage, FirebaseStorage } from 'firebase/storage'

@Injectable({ providedIn: 'root' })
export class FirebaseService {
  private readonly app = getFirebaseApp()!
  readonly auth: Auth = getAuth(this.app)
  readonly firestore: Firestore = this.initializeFirestore()
  readonly functions: Functions = getFunctions(this.app, 'northamerica-northeast1')
  readonly storage: FirebaseStorage = getStorage(this.app)

  private initializeFirestore(): Firestore {
    try {
      return initializeFirestore(this.app, {
        localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
      })
    } catch (error) {
      // Unsupported IndexedDB environments and a second initializer must not
      // prevent startup. getFirestore returns the already-created instance in
      // the latter case and an in-memory instance in the former.
      console.warn('[Firebase] Persistent Firestore cache unavailable; using existing/in-memory cache:', error)
      return getFirestore(this.app)
    }
  }
}
